/* Supplier order page: search the CMS supplier catalogue via
   the external search service. Prices come back as selling prices only. */
(function () {
  'use strict';
  var root = document.querySelector('[data-supplier-order]');
  if (!root) return;
  var api = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
  var form = root.querySelector('[data-supplier-form]');
  var input = root.querySelector('[data-supplier-input]');
  var makeSel = root.querySelector('[data-supplier-make]');
  var statusEl = root.querySelector('[data-supplier-status]');
  var list = root.querySelector('[data-supplier-results]');
  var moreBtn = root.querySelector('[data-supplier-more]');
  var submitBtn = root.querySelector('[data-supplier-submit]');
  var caveats = root.querySelector('[data-supplier-caveats]');

  /* Makes Jack sells (whitelist); the service narrows this to the makes that are live. */
  var FALLBACK_MAKES = [
    ['BM', 'BMW'], ['DU', 'Ducati'], ['HO', 'Honda'], ['KA', 'Kawasaki'],
    ['PI', 'Piaggio'], ['SU', 'Suzuki'], ['TR', 'Triumph'], ['YA', 'Yamaha']
  ];
  var makesNotice = '';
  var T = window.theme || {};
  var seq = 0, page = 1, current = { q: '', make: '' }, controller = null, typeTimer = 0;
  var wantScroll = false, caveatsTouched = false, caveatsAuto = false;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia && window.matchMedia('(max-width: 749px)');
  /* Landing with ?q= (set note, search forward, any link): bring the results into view once they
     render, unless the customer has already touched/scrolled the page or this is a back/forward visit. */
  var loadScroll = false, userMoved = false;
  ['touchstart', 'wheel', 'keydown', 'pointerdown'].forEach(function (t) {
    window.addEventListener(t, function () { userMoved = true; }, { passive: true, capture: true });
  });
  var navEntry = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
  var cameBack = (navEntry && navEntry.type === 'back_forward') || (window.performance && performance.navigation && performance.navigation.type === 2);

  /* "Before you order": open before any search; folded to a compact disclosure once a search
     has run (results sit above it). Once the customer opens/closes it themselves, leave it be. */
  function foldCaveats(fold) {
    if (!caveats || caveatsTouched || caveats.open === !fold) return;
    caveatsAuto = true;
    caveats.open = !fold;
    root.classList.toggle('is-searched', fold);
  }
  if (caveats) caveats.addEventListener('toggle', function () {
    if (caveatsAuto) { caveatsAuto = false; return; }
    caveatsTouched = true;
  });
  function setBusy(on) {
    if (on) root.setAttribute('aria-busy', 'true'); else root.removeAttribute('aria-busy');
    if (submitBtn) submitBtn.classList.toggle('is-loading', !!on);
  }
  /* Phones: after a search the customer tapped, bring the summary line up under the sticky
     header if it's out of view (keyboard closing / notes above can leave it off-screen). */
  function revealResults() {
    if (!wantScroll) return;
    wantScroll = false;
    var onLoad = loadScroll; loadScroll = false;
    if (onLoad && (userMoved || window.pageYOffset > 40)) return;
    if (!onLoad && (!phone || !phone.matches)) return;   /* Search pressed: phones only (as before) */
    requestAnimationFrame(function () {
      /* Phones pin only the slim logo/Account/Cart bar (theme.js: html.hdr-bar-fixed, --hdr-bar-h). */
      var de = document.documentElement, head = document.querySelector('.section-header') || document.querySelector('.header');
      var hb = 0;
      if (de.classList.contains('hdr-bar-fixed')) {
        hb = parseFloat(getComputedStyle(de).getPropertyValue('--hdr-bar-h')) || 62;
      } else if (head) {
        var pos = getComputedStyle(head).position;
        if (pos === 'sticky' || pos === 'fixed') hb = Math.max(0, head.getBoundingClientRect().bottom);
      }
      var s = statusEl.getBoundingClientRect();
      var first = list.hidden ? null : list.firstElementChild;
      var endY = first ? Math.min(first.getBoundingClientRect().bottom, s.top + window.innerHeight * 0.5) : s.bottom;
      if (s.top >= hb + 4 && endY <= window.innerHeight - 8) return;
      window.scrollTo({ top: Math.max(0, s.top + window.pageYOffset - hb - 12), behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth' });
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    var n = Number(v);
    return '\u00a3' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  var tipN = 0;
  function priceHtml(r) {
    if (r.incVat == null) return '<p class="supplier-row__poa">Price on request</p>';
    var id = 'so-vat-' + (++tipN);
    var tip = T.vatTip || 'Only UK customers pay UK VAT (20%). Orders to the Channel Islands and outside the UK are charged without UK VAT. Import VAT or duty may apply in your country.';
    return '<div class="price-vat">' +
      '<span class="price-vat__inc">' + esc(money(r.incVat)) + ' <span class="price-vat__label">' + esc(T.vatInc || 'inc VAT') + '</span></span>' +
      '<span class="price-vat__ex">' + esc(money(r.exVat)) + ' <span class="price-vat__label">' + esc(T.vatEx || 'ex VAT') + '</span></span>' +
      '<span class="vat-info"><button type="button" class="vat-info__btn" aria-label="' + esc(T.vatInfo || 'VAT information') + '" aria-describedby="' + id + '">i</button>' +
      '<span class="vat-info__tip" id="' + id + '" role="tooltip">' + esc(tip) + '</span></span>' +
    '</div>';
  }
  /* Same supplier-order view, searching another part number (keeps preview_theme_id). */
  function codeHref(code) {
    var u = new URL(window.location.href);
    u.searchParams.set('q', code);
    u.searchParams.delete('make');
    u.searchParams.delete('page');
    return u.pathname + u.search;
  }
  /* A stocked match counts as "we sell this part" only when our product IS that single part
     (kind 'part'). Kits/sets that merely include it (kind 'kit') get a quiet line instead. */
  function isPart(st) { return !!(st && st.handle && st.kind !== 'kit'); }
  function isKit(st) { return !!(st && st.handle && st.kind === 'kit'); }
  function kitHtml(r) {
    var st = null, lead = 'Also included in our ';
    if (isKit(r.stocked)) st = r.stocked;
    else if (r.replacedBy && isKit(r.replacedBy.stocked)) { st = r.replacedBy.stocked; lead = 'The replacement is also included in our '; }
    if (!st) return '';
    return '<p class="supplier-row__kit">' + esc(lead) +
      '<a href="/products/' + esc(encodeURIComponent(st.handle)) + '">' + esc(st.title) + '</a></p>';
  }
  /* "Replaced by 18311-341-901P": the superseding number from the supplier file. */
  function replHtml(r) {
    var rb = r.replacedBy;
    if (!rb || !rb.code) return '';
    var code = rb.inCatalogue || (rb.stocked && rb.stocked.handle)
      ? '<a href="' + esc(codeHref(rb.code)) + '" data-supplier-code="' + esc(rb.code) + '">' + esc(rb.code) + '</a>'
      : esc(rb.code);
    var extra = '';
    if (isPart(rb.stocked) && !isPart(r.stocked)) {
      extra = '';                       /* shown as the stocked replacement row below */
    } else if (isPart(rb.stocked)) {
      extra = ' · <a href="/products/' + esc(encodeURIComponent(rb.stocked.handle)) + '">we sell it</a>';
    }
    return '<p class="supplier-row__repl">Replaced by ' + code + extra + '</p>';
  }
  /* Pattern (aftermarket) parts: flagged by the service (trailing P for Honda, or a NON O.E. description). */
  function patternHtml(r) {
    if (!r.pattern) return '';
    var endsP = /P$/i.test(String(r.code || '').replace(/[^A-Za-z0-9]/g, ''));
    return '<p class="supplier-row__pattern"><span class="supplier-pattern-badge">Pattern / aftermarket</span>' +
      '<span class="supplier-row__pattern-note">' + (endsP ? 'Part numbers ending in P are usually pattern (non-genuine) parts.' : 'Listed by our supplier as a non-genuine alternative.') + '</span></p>';
  }
  /* Backorder pill: same amber pill as the cart (display only). */
  function boHtml() {
    return '<p class="supplier-row__bo"><span class="bo-badge">Backordered 1\u20134 weeks</span></p>';
  }
  function rowHtml(r) {
    if (isPart(r.stocked)) return stockedHtml(r, r.stocked, 'We sell this part');
    if (r.replacedBy && isPart(r.replacedBy.stocked))
      return stockedHtml(r, r.replacedBy.stocked, 'We sell the replacement');
    var save = saveHtml(r);
    return '<li class="supplier-row' + (save ? ' supplier-row--savable' : '') + '">' + save +
      '<div class="supplier-row__main">' +
        '<p class="supplier-row__meta"><span class="supplier-row__make">' + esc(r.makeName) + '</span>' +
        '<span class="supplier-row__code">' + esc(r.code) + '</span></p>' +
        '<p class="supplier-row__desc">' + esc(r.description) + '</p>' + replHtml(r) + patternHtml(r) + boHtml() + kitHtml(r) +
      '</div>' +
      '<div class="supplier-row__side">' + priceHtml(r) + buyHtml(r) +
      '</div>' +
    '</li>';
  }
  /* We already sell this part in the shop: show our price and link to it
     instead of a supplier order (no stock levels shown). */
  function stockedHtml(r, st, badge) {
    var href = '/products/' + encodeURIComponent(st.handle);
    return '<li class="supplier-row supplier-row--stocked">' +
      '<div class="supplier-row__main">' +
        '<p class="supplier-row__meta"><span class="supplier-row__make">' + esc(r.makeName) + '</span>' +
        '<span class="supplier-row__code">' + esc(r.code) + '</span>' +
        '<span class="supplier-row__badge">' + esc(badge) + '</span>' +
        ((r.own ? r.available : ownAvail[st.handle]) ? '<span class="stock-badge supplier-row__stock">In stock</span>' : '') + '</p>' +
        (r.description ? '<p class="supplier-row__desc">' + esc(r.description) + '</p>' : '') + replHtml(r) +
        '<p class="supplier-row__shop"><a href="' + esc(href) + '">' + esc(st.title) + '</a></p>' +
      '</div>' +
      '<div class="supplier-row__side">' +
        (st.incVat == null ? '' : priceHtml(st)) +
        '<a class="supplier-row__view" href="' + esc(href) + '">View part</a>' +
      '</div>' +
    '</li>';
  }

  /* Save (bookmark) for the Saved page: same round icon and toggle as the product cards' Save,
     in the row's top-right corner, well away from Add to basket. Identity only is saved;
     the Saved page fetches today's price. Shown when Save buttons are on, like the cards. */
  var BM_SVG = '<svg class="supplier-row__save-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6.5 3.75h11a.75.75 0 0 1 .75.75v15.6a.4.4 0 0 1-.63.33L12 16.6l-5.62 3.83a.4.4 0 0 1-.63-.33V4.5a.75.75 0 0 1 .75-.75Z"/></svg>';
  function saveHtml(r) {
    if (!window.SupplierSaved || r.incVat == null) return '';
    var key = r.make + '|' + r.code, on = window.SupplierSaved.has(key);
    rowsByKey[key] = r;
    return '<button type="button" class="supplier-row__save" data-supplier-save="' + esc(key) + '" aria-pressed="' + on + '" aria-label="' + (on ? 'Remove from saved' : 'Save to list') + '">' + BM_SVG + '</button>';
  }
  function paintSaves(popKey) {
    if (!window.SupplierSaved) return;
    Array.prototype.forEach.call(list.querySelectorAll('[data-supplier-save]'), function (b) {
      var k = b.getAttribute('data-supplier-save'), on = window.SupplierSaved.has(k);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from saved' : 'Save to list');
      if (on && k === popKey) { b.classList.remove('is-popping'); void b.offsetWidth; b.classList.add('is-popping'); }
    });
  }
  document.addEventListener('supplier-saved:change', function () { paintSaves(); });

  /* Add to basket: the part goes into the supplier basket (supplier-basket.js,
     localStorage) and is checked out together with the Shopify cart through a
     server-priced draft order. Only rows with a price that we don't stock. */
  var rowsByKey = {};
  function buyHtml(r) {
    if (!window.SupplierBasket || r.incVat == null) return '<p class="supplier-row__note">Ordering coming soon</p>';
    var key = r.make + '|' + r.code;
    rowsByKey[key] = r;
    var inB = inBasket(key);
    if (!inB) delete addedHere[key];
    return '<button type="button" class="product-card__add supplier-row__buy" data-supplier-buy="' + esc(key) + '">Add to cart</button>' +
      '<p class="supplier-row__inbasket" data-supplier-inbasket="' + esc(key) + '" aria-live="polite">' +
      noteHtml(key, inB) + '</p>';
  }
  function inBasket(key) {
    var q = 0;
    window.SupplierBasket.read().forEach(function (l) { if (l.make + '|' + l.code === key) q = l.qty; });
    return q;
  }
  /* Green "Already in your basket" strip (styles .inb in theme.css, same as the search supplier cards). */
  function inBasketHtml(q) {
    return '<span class="inb"><span class="inb__icon" aria-hidden="true">\u2713</span>' +
      '<span class="inb__txt">Already in your cart: <strong class="inb__q">' + q + '</strong></span>' +
      '<a class="inb__link" href="/cart">View cart</a></span>';
  }
  /* Parts added on THIS results view (reset on every new search render and on Back) show no note at all
     (just the button's brief "Added" and the header cart badge), so one click never looks like two. The
     green strip is only for rows that render with the part already in the cart from before. */
  var addedHere = {};
  function noteHtml(key, q) {
    if (!q || addedHere[key]) return '';
    return inBasketHtml(q);
  }
  /* Keep every row's note in step with the cart (add here, qty change / remove on another page or tab). */
  function paintInBasket() {
    if (!window.SupplierBasket || !list) return;
    Array.prototype.forEach.call(list.querySelectorAll('[data-supplier-inbasket]'), function (n) {
      var key = n.getAttribute('data-supplier-inbasket'), q = inBasket(key);
      if (!q) delete addedHere[key];
      var sig = (addedHere[key] ? 'a' : 's') + q;
      if (n.getAttribute('data-q') === sig) return;
      n.setAttribute('data-q', sig);
      n.innerHTML = noteHtml(key, q);
    });
  }
  document.addEventListener('supplier-basket:change', paintInBasket);
  window.addEventListener('storage', function (e) { if (!e.key || e.key === 'shire-supplier-basket-v1') paintInBasket(); });
  /* Back (bfcache) counts as a return visit: rows in the cart show the prominent strip again. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { addedHere = {}; paintInBasket(); } });
  function buy(btn) {
    var key = btn.getAttribute('data-supplier-buy'), r = rowsByKey[key];
    if (!r || btn.disabled) return;
    addedHere[key] = true;
    var q = window.SupplierBasket.add(r);
    btn.disabled = true; btn.classList.add('is-added'); btn.textContent = 'Added';
    var note = list.querySelector('[data-supplier-inbasket="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (note) { note.innerHTML = ''; note.setAttribute('data-q', 'a' + q); }
    window.SupplierBasket.refreshBadge();
    setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; btn.textContent = 'Add to cart'; }, 1200);
  }

  /* ---------- Own-catalogue lookup ----------
     Every search also checks Shire's own Shopify catalogue (the theme's search.ajax view,
     same as the site search), so parts we sell show as "We sell this part" even when the
     supplier file has no row for them. Matches the typed number with or without dashes or
     spaces against variant SKUs and the product description. Not affected by the make
     filter or the supplier-file exclusions. */
  function compact(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function dashVariants(c) {
    var L = c.length, out = [];
    function cut(sizes) {
      var parts = [], start = 0;
      for (var i = 0; i < sizes.length; i++) {
        if (start + sizes[i] >= L) return;
        parts.push(c.slice(start, start + sizes[i])); start += sizes[i];
      }
      parts.push(c.slice(start));
      var v = parts.join('-'); if (out.indexOf(v) === -1) out.push(v);
    }
    if (L >= 9) cut([5, 3]); if (L >= 6) cut([5]); if (L >= 8) cut([3]);
    if (L >= 7) cut([2, 2]); if (L >= 8) cut([2, 3]); if (L >= 8) cut([4]);
    return out;
  }
  var KIT_TITLE = /\b(?:sets?|kits?)\b/i;
  function ownFetch(query, signal) {
    return fetch('/search?q=' + encodeURIComponent(query) + '&type=product&view=ajax&page=1',
      { signal: signal, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return (d && Array.isArray(d.products)) ? d.products : []; })
      .catch(function (e) { if (e && e.name === 'AbortError') throw e; return []; });
  }
  /* Which of our products carry this number: SKU starting with it (supplier search also
     matches the start of the number), or the full number in the description (single parts
     only; sets/kits that list it are left to the supplier row). */
  function ownMatch(p, c) {
    var vs = (p.variants && p.variants.length) ? p.variants : [{ sku: p.sku, price: p.price, available: p.available }];
    for (var i = 0; i < vs.length; i++) {
      var sk = compact(vs[i].sku);
      if (sk && (sk === c || (c.length >= 5 && sk.indexOf(c) === 0))) return { sku: vs[i].sku, v: vs[i] };
    }
    if (c.length >= 6 && !KIT_TITLE.test(p.title || '') &&
        (p.pn_hit === true || compact(p.description).indexOf(c) !== -1)) {
      var av = null;
      vs.forEach(function (v) { if (!av && v.available) av = v; });
      return { sku: null, v: av || vs[0] };
    }
    return null;
  }
  function ownLookup(q, signal) {
    var c = compact(q);
    if (c.length < 4) return Promise.resolve([]);
    var typed = String(q).trim().replace(/\s+/g, ' ');
    var qs = [];
    function add(x) { if (x && qs.indexOf(x) === -1) qs.push(x); }
    add(typed); add(c); dashVariants(c).forEach(add);
    function stage(list) {
      return Promise.all(list.map(function (x) { return ownFetch(x, signal); })).then(function (lists) {
        var seen = {}, out = [];
        lists.forEach(function (ps) {
          ps.forEach(function (p) {
            var key = String(p.id || p.handle);
            if (seen[key]) return;
            var m = ownMatch(p, c);
            if (!m) return;
            seen[key] = true;
            out.push({ p: p, m: m });
          });
        });
        return out;
      });
    }
    return stage(qs).then(function (hits) {
      if (hits.length) return hits;
      /* Storefront search often misses dashed numbers in descriptions unless quoted. */
      return stage(dashVariants(c).concat(typed.indexOf('-') !== -1 ? [typed] : []).map(function (v) { return '"' + v + '"'; }));
    }).then(function (hits) {
      hits.sort(function (a, b) {
        return (compact(b.m.sku) === c) - (compact(a.m.sku) === c) || (!!b.m.sku - !!a.m.sku) ||
          (!!b.m.v.available - !!a.m.v.available);
      });
      return hits.slice(0, 12).map(function (h) {
        var p = h.p, v = h.m.v || {}, pr = v.price != null ? v.price : p.price;
        var ex = pr == null ? null : Math.round(Number(pr));
        var inc = ex == null ? null : Math.floor((ex * 12 + 5) / 10);
        return {
          own: true,
          makeName: p.vendor || '',
          code: h.m.sku || typed.toUpperCase(),
          description: '',
          available: !!(v.available != null ? v.available : p.available),
          stocked: { kind: 'part', handle: p.handle, title: p.title,
            exVat: ex == null ? null : (ex / 100).toFixed(2),
            incVat: inc == null ? null : (inc / 100).toFixed(2) }
        };
      });
    });
  }
  /* Handles already shown as "we sell" by a supplier row (so own rows don't repeat them). */
  function stockedHandles(rows) {
    var h = {};
    rows.forEach(function (r) {
      if (isPart(r.stocked)) h[r.stocked.handle] = true;
      if (r.replacedBy && isPart(r.replacedBy.stocked)) h[r.replacedBy.stocked.handle] = true;
    });
    return h;
  }
  var ownAvail = {};
  function ownTimeout(p, ms) {
    return Promise.race([p, new Promise(function (res) { setTimeout(function () { res([]); }, ms); })]);
  }

  function skeleton() {
    var s = '';
    for (var i = 0; i < 2; i++) {
      s += '<li class="supplier-row supplier-row--skel" aria-hidden="true"><div class="supplier-row__main">' +
        '<span class="so-skel so-skel--a"></span><span class="so-skel so-skel--b"></span></div>' +
        '<div class="supplier-row__side"><span class="so-skel so-skel--c"></span></div></li>';
    }
    return s;
  }
  function setStatus(html, kind) {
    statusEl.innerHTML = html || '';
    statusEl.setAttribute('data-kind', kind || '');
  }
  function syncUrl() {
    try {
      var u = new URL(window.location.href);
      if (current.q) u.searchParams.set('q', current.q); else u.searchParams.delete('q');
      if (current.make) u.searchParams.set('make', current.make); else u.searchParams.delete('make');
      window.history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function idle() {
    setBusy(false); wantScroll = false; foldCaveats(false);
    list.hidden = true; list.innerHTML = ''; moreBtn.hidden = true;
    setStatus('Enter a part number, e.g. <b>18311-341-900</b>. Dashes and spaces are optional.' +
      (makesNotice ? '<br>' + esc(makesNotice) : ''), 'idle');
  }
  /* Part numbers only (same rule as the search service): 4+ letters/digits, a digit, only code
     characters, and every space-separated chunk has a digit (short suffixes like "ZA" allowed). */
  var NOT_CODE_MSG = 'Please enter a part number. This page searches by part number only.';
  function isPartNumber(q) {
    var t = String(q || '').trim(), n = t.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (n.length < 4 || !/[0-9]/.test(n) || !/^[A-Za-z0-9\s\-.\/]+$/.test(t)) return false;
    return t.split(/\s+/).every(function (w) { return /[0-9]/.test(w) || w.replace(/[^A-Za-z0-9]/g, '').length <= 3; });
  }
  function notCode() {
    if (controller) controller.abort();
    seq++;
    setBusy(false);
    list.hidden = true; list.innerHTML = ''; moreBtn.hidden = true;
    setStatus('<span class="supplier-order__empty-title">' + esc(NOT_CODE_MSG) + '</span>' +
      '<span class="supplier-order__empty-tip">For example 18311-341-900 or 18311341900.</span>', 'empty');
    revealResults();
  }

  function run(append) {
    var q = input.value.trim().slice(0, 80);
    var make = makeSel.value;
    if (!append) { page = 1; current = { q: q, make: make }; syncUrl(); addedHere = {}; }
    if (q.length < 2) { if (controller) controller.abort(); idle(); return; }
    if (!isPartNumber(q)) { notCode(); return; }
    if (!api || /REPLACE/.test(api)) { showError(true); return; }
    var my = ++seq;
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    setBusy(true);
    if (append) {
      moreBtn.disabled = true;
      moreBtn.textContent = 'Loading\u2026';
    } else {
      list.hidden = false;
      list.innerHTML = skeleton();
      moreBtn.hidden = true;
      setStatus('Searching\u2026', 'loading');
      /* Notes stay open after a search (no auto-fold); the customer can still fold them. */
    }
    var url = api + '/search?q=' + encodeURIComponent(q) + (make ? '&make=' + make : '') + '&page=' + page;
    var sig = controller ? controller.signal : undefined;
    /* Own catalogue: first page only; never blocks the supplier results for long. */
    var ownP = append ? Promise.resolve([]) : ownTimeout(ownLookup(q, sig).catch(function () { return []; }), 6000);
    var supP = fetch(url, { signal: sig, headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (res.status === 429) { var e = new Error('busy'); e.busy = true; throw e; }
        if (!res.ok) throw new Error('bad');
        return res.json();
      });
    Promise.all([supP.then(function (d) { return { d: d }; }, function (err) { return { err: err }; }), ownP])
      .then(function (both) {
        var own = both[1] || [];
        if (!append) { ownAvail = {}; own.forEach(function (o) { if (o.available) ownAvail[o.stocked.handle] = true; }); }
        if (both[0].err) {
          var err = both[0].err;
          if (err && err.name === 'AbortError') throw err;
          if (!own.length) throw err;
          both[0].d = { type: 'code', results: [], hasMore: false, supplierDown: true };
        }
        return { data: both[0].d, own: own };
      })
      .then(function (res2) {
        var data = res2.data, own = res2.own;
        if (my !== seq) return;
        setBusy(false);
        if (data && data.type === 'notcode') { notCode(); return; }
        if (data && data.type === 'make' && own.length) data = { type: 'code', results: [], hasMore: false, makeMsg: data.message };
        if (data && data.type === 'make') {
          list.hidden = true; list.innerHTML = ''; moreBtn.hidden = true;
          setStatus('<span class="supplier-order__empty-title">' + esc(data.message || 'We can\u2019t take supplier orders for that make.') + '</span>' +
            '<span class="supplier-order__empty-tip">Choose All makes, or another make from the list.</span>', 'empty');
          revealResults();
          return;
        }
        var rows = (data && data.results) || [];
        if (!append && own.length) {
          /* A supplier row for a number we sell (the import map missed it): show it as ours. */
          rows.forEach(function (r) {
            if (isPart(r.stocked) || (r.replacedBy && isPart(r.replacedBy.stocked))) return;
            var hit = null;
            own.forEach(function (o) { if (!hit && o.code && compact(o.code) === compact(r.code)) hit = o; });
            if (hit) r.stocked = hit.stocked;
          });
          var dup = stockedHandles(rows);
          rows = own.filter(function (o) { return !dup[o.stocked.handle]; }).concat(rows);
        }
        if (!append && !rows.length) {
          list.hidden = true; list.innerHTML = ''; moreBtn.hidden = true;
          setStatus('<span class="supplier-order__empty-title">No supplier parts matched \u201c' + esc(q) + '\u201d' +
            (make ? ' for ' + esc(makeSel.options[makeSel.selectedIndex].text) : '') + '.</span>' +
            '<span class="supplier-order__empty-tip">Check the part number' + (make ? ' or choose All makes' : '') + '. Searches match the start of the number, so try fewer characters.</span>', 'empty');
          revealResults();
          return;
        }
        var html = rows.map(rowHtml).join('');
        if (append) list.insertAdjacentHTML('beforeend', html);
        else { list.innerHTML = html; list.hidden = false; }
        var shown = list.children.length;
        setStatus(shown + (data.hasMore ? '+' : '') + (shown === 1 ? ' part' : ' parts') +
          (data.type === 'code' ? ' with part numbers starting \u201c' + esc(q) + '\u201d' : ' matching \u201c' + esc(q) + '\u201d') +
          (data.supplierDown ? '. Supplier search isn\u2019t available right now, so only parts we stock are shown.' : '') +
          (data.makeMsg ? '. ' + esc(data.makeMsg) : ''), 'results');
        moreBtn.hidden = !data.hasMore;
        moreBtn.disabled = false;
        moreBtn.textContent = 'Show more results';
        if (!append) revealResults();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (my !== seq) return;
        setBusy(false);
        if (append) {
          page = Math.max(1, page - 1);
          moreBtn.disabled = false;
          moreBtn.textContent = 'Try again';
          return;
        }
        showError(false, err && err.busy);
      });
  }
  function showError(unconfigured, busy) {
    setBusy(false);
    list.hidden = true; list.innerHTML = ''; moreBtn.hidden = true;
    setStatus('<span class="supplier-order__empty-title">' +
      (busy ? 'Lots of searches just now.' : 'Supplier search isn\u2019t available right now.') + '</span>' +
      '<span class="supplier-order__empty-tip">' + (unconfigured ? 'The search service hasn\u2019t been connected yet.' : 'Please try again in a moment.') + '</span>' +
      (unconfigured ? '' : '<button type="button" class="supplier-order__retry" data-supplier-retry>Try again</button>'), 'error');
    revealResults();
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearTimeout(typeTimer);
    input.blur();
    wantScroll = true;
    run(false);
  });
  input.addEventListener('input', function () {
    clearTimeout(typeTimer);
    typeTimer = setTimeout(function () { run(false); }, 450);
  });
  makeSel.addEventListener('change', function () { run(false); });
  moreBtn.addEventListener('click', function () { page += 1; run(true); });
  list.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-supplier-buy]');
    if (b) { e.preventDefault(); buy(b); return; }
    var sv = e.target.closest && e.target.closest('[data-supplier-save]');
    if (sv) {
      e.preventDefault();
      var sk = sv.getAttribute('data-supplier-save');
      if (rowsByKey[sk] && window.SupplierSaved) { window.SupplierSaved.toggle(rowsByKey[sk]); paintSaves(sk); }
      return;
    }
    var a = e.target.closest && e.target.closest('a[data-supplier-code]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    e.preventDefault();
    input.value = a.getAttribute('data-supplier-code');
    if (makeSel) makeSel.value = '';
    run(false);
    window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
  });
  statusEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-supplier-retry]')) run(false);
  });

  function fillMakes(makes, selected) {
    makes.forEach(function (m) {
      var o = document.createElement('option');
      o.value = m[0]; o.textContent = m[1];
      makeSel.appendChild(o);
    });
    if (selected) makeSel.value = selected;
  }

  var params = new URLSearchParams(window.location.search);
  var q0 = (params.get('q') || '').slice(0, 80);
  var make0 = (params.get('make') || '').toUpperCase();
  input.value = q0;

  var makesReady = (api && !/REPLACE/.test(api))
    ? fetch(api + '/makes', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var m = d && d.makes ? d.makes.map(function (x) { return [x.make, x.name]; }) : FALLBACK_MAKES;
          if (d && d.makes && d.makes.length < FALLBACK_MAKES.length && d.notice) makesNotice = d.notice;
          m.sort(function (a, b) { return a[1].localeCompare(b[1]); });
          fillMakes(m, make0);
        }).catch(function () { fillMakes(FALLBACK_MAKES, make0); })
    : Promise.resolve(fillMakes(FALLBACK_MAKES, make0));

  makesReady.then(function () {
    if (q0.trim().length >= 2) { wantScroll = loadScroll = !cameBack; run(false); } else idle();
  });
})();
